import { Directive, HostListener, Input } from '@angular/core';
import { PharmaciesNavigationHelperService } from 'src/app/core/services/helpers/help-service-for-search-page/pharmacies-navigation-helper.service';

@Directive({
  selector: '[navigateEmitter]'
})
export class NavigateEmitterDirective {

  constructor(
    private readonly navigationHelper: PharmaciesNavigationHelperService
  ) { }

  @HostListener('click', ['$event']) public emmitNavigationEvent(): void {
    this.navigationHelper.emittNavigation();
  }

}
